<div class="blogs-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.blogs_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.blogs_title' | translate }}</h2>
    </div>
    <button class="lx-btn lx-btn--primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      <span class="material-symbols-outlined">add</span>
      {{ 'btn.add_blog' | translate }}
    </button>
  </div>

  <div class="app-card blogs-table-card">
    <div class="lx-table-wrap">
      <table class="lx-table" *ngIf="!showMessage">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.title' | translate }}</th>
            <th>{{ 'lbl.date' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of blogsArr" (click)="blogDetails(item.id)">
            <td class="cell-muted">{{ item.id }}</td>
            <td>{{ item.title }}</td>
            <td class="cell-date">{{ item.joined_date | date : "d MMM y" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lx-empty" *ngIf="showMessage">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">article</span>
      </div>
      <h3>{{ 'empty.blogs' | translate }}</h3>
      <p>{{ 'empty.blogs_sub' | translate }}</p>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Add Blog Modal
════════════════════════════════════════ -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.blogs_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'btn.add_blog' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <div *ngIf="!showUploadFile">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.title_label' | translate }}</label>
            <input [(ngModel)]="title" type="text" class="lx-input" [placeholder]="'ph.blog_title' | translate" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.content_label' | translate }}</label>
            <textarea [(ngModel)]="content" class="lx-input lx-textarea" [placeholder]="'ph.blog_content' | translate"></textarea>
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.steps_label' | translate }}</label>
            <input [(ngModel)]="steps" type="text" class="lx-input" [placeholder]="'ph.blog_steps' | translate" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.linked_products' | translate }}</label>
            <div class="lx-dropdown-wrap">
              <button class="lx-dropdown-btn" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                <span class="material-symbols-outlined">inventory_2</span>
                {{ 'blog.choose_product' | translate }}
                <span class="material-symbols-outlined lx-dropdown-caret">expand_more</span>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li *ngFor="let item of allProductsArray">
                  <a class="dropdown-item" *ngIf="item.quantity > 0" (click)="choseProd(item)">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="lx-tag-list" *ngIf="idOfProducts.length > 0">
              <span class="lx-tag" *ngFor="let item of idOfProducts">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="showUploadFile">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.images_label' | translate }}</label>
            <input multiple (change)="uploadFile($event, 'main')" type="file" class="lx-input lx-file-input" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'blog.video_label' | translate }}</label>
            <input multiple (change)="uploadFile($event, 'video')" type="file" class="lx-input lx-file-input" />
          </div>
        </div>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button *ngIf="!showUploadFile" (click)="addBlog()" type="button" class="lx-btn lx-btn--primary">
          {{ 'btn.continue' | translate }}
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>
        <button *ngIf="showUploadFile" (click)="addBlogImage()" data-bs-dismiss="modal" type="button" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_blog' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
